import Vue from "vue";
import Vuex from "vuex";

import Auth from "./modules/auth.module";

// @ts-ignore
import VueSanitize from "vue-sanitize";

const sanitizeOptions = {
  allowedTags: ['br'],
};
Vue.use(VueSanitize, sanitizeOptions);

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    Auth
  }
});

export default store;